// eslint-disable-next-line
function dataRatingsAdapter(ratings) {
  if (!ratings) return {};
  if (ratings) {
    return {
      generalScore: ratings.generalScore,
      totalRatings: ratings.receivedRatings,
      notRespondedCount: ratings.publisherDidntRepliedCount,
      responseTime: ratings.rating && ratings.rating.responseTime,
      postingContent: ratings.rating && ratings.rating.postingContent,
      attention: ratings.rating && ratings.rating.atention,
      recommendYou: ratings.rating && ratings.rating.recommendation
    };
  }
}

export { dataRatingsAdapter };
